import * as React from "react";
const SvgFiBrandsTwitterAltSquare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-twitter-alt-square_svg__a)">
      <path d="m7.147 6.16 9.246 11.604h1.416L8.67 6.16z" />
      <path d="M0 0v24h25V0zm15.69 19.232-4.03-5.055-4.607 5.055h-2.56l5.972-6.554-6.298-7.91H9.44l3.64 4.621 4.21-4.621h2.558l-5.584 6.126 6.57 8.337z" />
    </g>
    <defs>
      <clipPath id="fi-brands-twitter-alt-square_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsTwitterAltSquare;
